import script from "./WebHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./WebHeader.vue?vue&type=script&setup=true&lang=js"

import "./WebHeader.vue?vue&type=style&index=0&id=d349a4de&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d349a4de"]])

export default __exports__
import QHeader from 'quasar/src/components/header/QHeader.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QHeader,QSeparator,QBtn,QMenu,QList,QItem,QItemSection});qInstall(script, 'directives', {ClosePopup});
